import { useSyncExternalStore } from 'react';

let mountedCount = 0;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = (): number => mountedCount;

const notify = (): void => {
  listeners.forEach((listener) => listener());
};

/**
 * Increments the mount count and returns a cleanup function that decrements
 * it. Designed for `useEffect(() => registerPrototypeMount(), [])` so the
 * cleanup runs on unmount.
 */
export const registerPrototypeMount = (): (() => void) => {
  mountedCount += 1;
  notify();
  return () => {
    mountedCount -= 1;
    notify();
  };
};

/**
 * `true` when at least one `<PrototypeBoundary>` is currently mounted. Drives
 * the viewport-level prototype indicator so it appears only when prototype
 * content is on screen.
 */
export const useHasMountedPrototype = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot) > 0;
